import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'complete-subscription',
  async getComponent () {
    const {
      default: CompleteSubscriptionContainer
    } = await import(/* webpackChunkName: "complete-subscription-container" */ './containers/CompleteSubscriptionContainer')
      .catch(handleChunkLoadError);
    return CompleteSubscriptionContainer;
  },
  getData ({ context: { props } }) {
    return props;
  }
});
